import React from 'react'
import * as languageColors from '../content/languageColors.json';

function getLangColor(lang){
  if (lang in languageColors){
    return languageColors[lang]["color"]
  }
  console.error("Language", lang, "not found in all languageColors!")
  return null;
}

const LanguagesBar = ( {languageDict, className} ) => {

  const barItems = Object.keys(languageDict).map((lang, idx) => {
    return <li key={lang} className='h-2 mr-0.5 w-full hover:scale-y-125' style={{
        backgroundColor: getLangColor(lang),
        width: `${languageDict[lang]*100}%`,
        borderRadius: idx === 0 ? 
                        (idx === Object.keys(languageDict).length - 1 ? 
                          "10px 10px 10px 10px" : "10px 0 0 10px")
                        : (idx === Object.keys(languageDict).length - 1 ? 
                          "0 10px 10px 0" : "")
      }}
    />
  });

  const listItems = Object.keys(languageDict).map((lang, idx) => {
    return <li key={`${lang}-name`} className="items-center mr-2 font-bold">
      <span className='rounded-full h-2 w-2 inline-block' style={{backgroundColor: getLangColor(lang)}}/>
      <span> {lang} </span><span className='text-dark-accent dark:text-light-accent2'>{languageDict[lang]*100}%</span>
    </li>
  });

  return (
    <div className={`pt-2 w-full ${className}`}>
      <h2 className='font-bold text-base'>Tech Stack:</h2>
      <div className='w-full'>
        <ul className='flex flex-row overflow-hidden list-none w-full m-0 p-0 items-center h-5'>
          {barItems}
        </ul>
        <ul className='flex flex-wrap'>
          {listItems}
        </ul>
      </div>
    </div>
  )
}

export default LanguagesBar



